export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  rating: number;
  views: number;
  description: string;
  chapters: Chapter[];
  status: '连载中' | '已完结';
  updateDate: string;
  tags: string[];
}

export interface Chapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', count: 128 },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 96 },
  { name: '动作', slug: 'action', icon: 'ri-sword-line', count: 87 },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 74 },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line', count: 63 },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line', count: 55 },
  { name: '都市', slug: 'urban', icon: 'ri-building-line', count: 48 },
  { name: '校园', slug: 'school', icon: 'ri-book-open-line', count: 42 },
];

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '她的私密日记',
    author: '金美珍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20art%20style%2C%20beautiful%20woman%20with%20long%20hair%20looking%20at%20a%20diary%2C%20soft%20pastel%20pink%20and%20cream%20background%2C%20delicate%20illustration%20with%20floral%20elements%2C%20manhwa%20aesthetic%2C%20clean%20line%20art%2C%20warm%20lighting%2C%20emotional%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-001&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    rating: 9.6,
    views: 1258000,
    description: '一个普通女孩意外发现了自己的日记拥有改变现实的神奇力量，每当她在日记中写下心愿，第二天就会实现。然而，这个秘密被她的青梅竹马发现了，两人之间展开了一段奇妙的浪漫故事。',
    chapters: [
      { id: 'ch-001-1', title: '第1话 神秘的日记本', number: 1, updateDate: '2026-08-01' },
      { id: 'ch-001-2', title: '第2话 第一个心愿', number: 2, updateDate: '2026-08-02' },
      { id: 'ch-001-3', title: '第3话 被发现了吗？', number: 3, updateDate: '2026-08-03' },
      { id: 'ch-001-4', title: '第4话 青梅竹马的秘密', number: 4, updateDate: '2026-08-04' },
      { id: 'ch-001-5', title: '第5话 雨天的约定', number: 5, updateDate: '2026-08-05' },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['恋爱', '奇幻', '校园', '甜宠'],
  },
  {
    id: 'comic-002',
    title: '剑与魔法之诗',
    author: '李东旭',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20cover%20art%2C%20warrior%20holding%20a%20glowing%20magic%20sword%20in%20epic%20battle%20pose%2C%20mystical%20forest%20background%20with%20floating%20light%20orbs%2C%20dramatic%20lighting%2C%20manhwa%20style%20illustration%2C%20rich%20color%20palette%2C%20detailed%20armor%20design%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-cover-002&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    rating: 9.8,
    views: 2340000,
    description: '在一个被魔法和剑统治的世界里，一个失去记忆的少年踏上了寻找真相的旅程。他遇到了各种各样的人，经历了无数次战斗，逐渐揭示出这个世界隐藏已久的秘密。',
    chapters: [
      { id: 'ch-002-1', title: '第1话 觉醒', number: 1, updateDate: '2026-08-01' },
      { id: 'ch-002-2', title: '第2话 第一场战斗', number: 2, updateDate: '2026-08-03' },
      { id: 'ch-002-3', title: '第3话 神秘的老者', number: 3, updateDate: '2026-08-05' },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['奇幻', '冒险', '战斗', '成长'],
  },
  {
    id: 'comic-003',
    title: '暗夜追踪者',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20thriller%20cover%2C%20detective%20in%20trench%20coat%20standing%20in%20rainy%20Seoul%20alley%20at%20night%2C%20neon%20signs%20reflecting%20on%20wet%20ground%2C%20noir%20atmosphere%2C%20manhwa%20style%2C%20dramatic%20shadows%2C%20high%20contrast%2C%20mysterious%20mood%2C%20digital%20illustration&width=400&height=560&seq=comic-cover-003&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    rating: 9.5,
    views: 1870000,
    description: '首尔深夜，连环杀手出没。退役特警韩泰宇成为私家侦探，接手了一桩看似普通的失踪案，却意外卷入了一场牵涉政商高层的巨大阴谋。每一步都危机四伏。',
    chapters: [
      { id: 'ch-003-1', title: '第1话 深夜来电', number: 1, updateDate: '2026-07-28' },
      { id: 'ch-003-2', title: '第2话 第一个线索', number: 2, updateDate: '2026-07-30' },
      { id: 'ch-003-3', title: '第3话 追踪', number: 3, updateDate: '2026-08-02' },
    ],
    status: '连载中',
    updateDate: '2026-08-02',
    tags: ['动作', '悬疑', '犯罪', '都市'],
  },
  {
    id: 'comic-004',
    title: '社长大人是猫咪',
    author: '崔秀英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20comedy%20cover%2C%20cute%20orange%20cat%20wearing%20a%20tiny%20business%20suit%20and%20tie%20sitting%20on%20an%20office%20desk%2C%20bright%20cheerful%20office%20background%2C%20funny%20and%20heartwarming%20manhwa%20style%2C%20vibrant%20colors%2C%20clean%20illustration%2C%20chibi%20elements&width=400&height=560&seq=comic-cover-004&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    rating: 9.3,
    views: 960000,
    description: '某天早上醒来，公司全体员工发现社长变成了一只橘猫！更神奇的是，这只猫居然能继续经营公司。一场荒诞又温馨的职场喜剧就此展开。',
    chapters: [
      { id: 'ch-004-1', title: '第1话 社长的猫耳朵', number: 1, updateDate: '2026-08-01' },
      { id: 'ch-004-2', title: '第2话 猫爪打字', number: 2, updateDate: '2026-08-02' },
      { id: 'ch-004-3', title: '第3话 会议室里的猫薄荷', number: 3, updateDate: '2026-08-04' },
    ],
    status: '连载中',
    updateDate: '2026-08-04',
    tags: ['搞笑', '职场', '萌宠', '日常'],
  },
  {
    id: 'comic-005',
    title: '第七层地狱',
    author: '金贤秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20horror%20thriller%20cover%2C%20dark%20staircase%20descending%20into%20shadows%2C%20red%20glowing%20eyes%20in%20the%20darkness%2C%20ominous%20atmosphere%2C%20manhwa%20horror%20style%2C%20dark%20crimson%20and%20black%20color%20scheme%2C%20psychological%20horror%20aesthetic%2C%20detailed%20illustration&width=400&height=560&seq=comic-cover-005&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    rating: 9.7,
    views: 1560000,
    description: '七个人被困在一栋神秘的大楼里，每一层都是一个恐怖的世界。他们必须一层一层往下走，但每下一层，就会有一个人消失。谁是幕后黑手？谁能活着离开？',
    chapters: [
      { id: 'ch-005-1', title: '第1话 醒来', number: 1, updateDate: '2026-07-29' },
      { id: 'ch-005-2', title: '第2话 第一层：镜之迷宫', number: 2, updateDate: '2026-07-31' },
      { id: 'ch-005-3', title: '第3话 消失的第一个人', number: 3, updateDate: '2026-08-02' },
      { id: 'ch-005-4', title: '第4话 第二层：血之回廊', number: 4, updateDate: '2026-08-04' },
    ],
    status: '连载中',
    updateDate: '2026-08-04',
    tags: ['悬疑', '恐怖', '生存', '推理'],
  },
  {
    id: 'comic-006',
    title: '那年夏天的约定',
    author: '郑恩地',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20romance%20cover%2C%20two%20young%20people%20sitting%20on%20a%20wooden%20pier%20overlooking%20calm%20blue%20sea%20at%20sunset%2C%20nostalgic%20summer%20atmosphere%2C%20manhwa%20style%2C%20warm%20golden%20hour%20lighting%2C%20emotional%20and%20beautiful%20illustration%2C%20soft%20color%20palette&width=400&height=560&seq=comic-cover-006&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    rating: 9.4,
    views: 1120000,
    description: '高中毕业那年的夏天，五个好朋友约定十年后再聚。十年后，有人功成名就，有人落魄潦倒，有人已经不在人世。当他们在故地重逢，那些尘封的往事和未说出口的话一一浮现。',
    chapters: [
      { id: 'ch-006-1', title: '第1话 十年前的夏天', number: 1, updateDate: '2026-08-03' },
      { id: 'ch-006-2', title: '第2话 重逢', number: 2, updateDate: '2026-08-04' },
      { id: 'ch-006-3', title: '第3话 缺席的人', number: 3, updateDate: '2026-08-05' },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['剧情', '青春', '友情', '成长'],
  },
  {
    id: 'comic-007',
    title: '都市夜行人',
    author: '张民浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20urban%20fantasy%20cover%2C%20young%20man%20in%20modern%20streetwear%20standing%20on%20Seoul%20rooftop%20at%20night%2C%20city%20skyline%20with%20neon%20lights%20in%20background%2C%20supernatural%20aura%20around%20him%2C%20manhwa%20style%2C%20vibrant%20neon%20colors%2C%20cool%20vibe&width=400&height=560&seq=comic-cover-007&orientation=portrait',
    category: '都市',
    categorySlug: 'urban',
    rating: 9.2,
    views: 890000,
    description: '在首尔繁华的夜景之下，隐藏着一个普通人看不见的世界。尹在赫白天是普通上班族，夜晚却是驱魔师后裔，守护着这座城市不被黑暗势力侵蚀。',
    chapters: [
      { id: 'ch-007-1', title: '第1话 月下的首尔', number: 1, updateDate: '2026-08-02' },
      { id: 'ch-007-2', title: '第2话 夜行', number: 2, updateDate: '2026-08-04' },
    ],
    status: '连载中',
    updateDate: '2026-08-04',
    tags: ['都市', '奇幻', '动作', '驱魔'],
  },
  {
    id: 'comic-008',
    title: '学霸的秘密',
    author: '刘智雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20romance%20cover%2C%20female%20student%20in%20school%20uniform%20standing%20in%20sunny%20classroom%2C%20holding%20books%2C%20cherry%20blossoms%20outside%20window%2C%20manhwa%20style%2C%20bright%20and%20fresh%20atmosphere%2C%20soft%20pastel%20colors%2C%20youthful%20energy%2C%20beautiful%20illustration&width=400&height=560&seq=comic-cover-008&orientation=portrait',
    category: '校园',
    categorySlug: 'school',
    rating: 9.1,
    views: 780000,
    description: '全校第一名的学霸林秀雅，其实有个不为人知的秘密——她每天放学后偷偷去漫画工作室画漫画。当校草发现她的秘密后，两人的关系发生了微妙的变化。',
    chapters: [
      { id: 'ch-008-1', title: '第1话 全校第一的秘密', number: 1, updateDate: '2026-08-01' },
      { id: 'ch-008-2', title: '第2话 被发现了', number: 2, updateDate: '2026-08-03' },
      { id: 'ch-008-3', title: '第3话 校草的提案', number: 3, updateDate: '2026-08-05' },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['校园', '恋爱', '青春', '励志'],
  },
  {
    id: 'comic-009',
    title: '魔女的条件',
    author: '韩智慧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20romance%20cover%2C%20beautiful%20witch%20with%20long%20silver%20hair%20and%20purple%20eyes%2C%20surrounded%20by%20floating%20magical%20runes%20and%20crystals%2C%20elegant%20dark%20gothic%20dress%2C%20mysterious%20moonlit%20garden%20background%2C%20manhwa%20style%2C%20enchanting%20atmosphere%2C%20detailed%20artwork&width=400&height=560&seq=comic-cover-009&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    rating: 9.9,
    views: 2890000,
    description: '世上最后一位魔女艾琳娜，为了解除自己永生不死的诅咒，需要找到真心爱她的人。然而在现代社会，这比任何魔法都要困难。当她遇到了不相信魔法的物理学教授，一切都开始变得不同。',
    chapters: [
      { id: 'ch-009-1', title: '第1话 最后的魔女', number: 1, updateDate: '2026-07-30' },
      { id: 'ch-009-2', title: '第2话 物理学教授', number: 2, updateDate: '2026-08-01' },
      { id: 'ch-009-3', title: '第3话 不可能的科学', number: 3, updateDate: '2026-08-03' },
      { id: 'ch-009-4', title: '第4话 心动的条件', number: 4, updateDate: '2026-08-05' },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['奇幻', '恋爱', '魔法', '治愈'],
  },
  {
    id: 'comic-010',
    title: '拳击手之魂',
    author: '姜泰雄',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20sports%20action%20cover%2C%20boxer%20with%20wrapped%20hands%20in%20fighting%20stance%20inside%20boxing%20ring%2C%20dramatic%20spotlight%20from%20above%2C%20sweat%20and%20determination%2C%20manhwa%20style%2C%20intense%20atmosphere%2C%20dynamic%20composition%2C%20powerful%20and%20evocative%20illustration&width=400&height=560&seq=comic-cover-010&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    rating: 9.7,
    views: 1980000,
    description: '曾经的天才拳击手崔民秀因伤退役后沦为街头混混，但命运给了他第二次机会。在恩师的鼓励下，他重新站上拳击台，向着冠军之巅发起冲击。',
    chapters: [
      { id: 'ch-010-1', title: '第1话 跌落', number: 1, updateDate: '2026-08-02' },
      { id: 'ch-010-2', title: '第2话 恩师', number: 2, updateDate: '2026-08-04' },
      { id: 'ch-010-3', title: '第3话 重返擂台', number: 3, updateDate: '2026-08-05' },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['动作', '运动', '热血', '励志'],
  },
  {
    id: 'comic-011',
    title: '甜蜜陷阱',
    author: '金美珍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%2C%20elegant%20woman%20in%20beautiful%20red%20dress%20and%20handsome%20man%20in%20black%20suit%20at%20luxurious%20party%2C%20champagne%20glasses%2C%20romantic%20tension%2C%20manhwa%20style%2C%20glamorous%20atmosphere%2C%20sparkling%20lights%2C%20sophisticated%20illustration&width=400&height=560&seq=comic-cover-011&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    rating: 9.5,
    views: 1760000,
    description: '为了揭露商业对手的阴谋，财阀继承人姜道允假扮成普通员工潜入竞争对手公司。他遇到了单纯善良的李彩琳，原本的计划开始偏离轨道。',
    chapters: [
      { id: 'ch-011-1', title: '第1话 潜入', number: 1, updateDate: '2026-08-02' },
      { id: 'ch-011-2', title: '第2话 新同事', number: 2, updateDate: '2026-08-03' },
      { id: 'ch-011-3', title: '第3话 心动警报', number: 3, updateDate: '2026-08-05' },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['恋爱', '职场', '财阀', '甜宠'],
  },
  {
    id: 'comic-012',
    title: '末日生存指南',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20apocalypse%20survival%20cover%2C%20group%20of%20survivors%20in%20ruined%20city%20with%20broken%20buildings%20and%20overgrown%20vegetation%2C%20dusk%20lighting%2C%20manhwa%20style%2C%20dramatic%20and%20hopeful%20atmosphere%2C%20detailed%20postapocalyptic%20scene%2C%20survival%20gear&width=400&height=560&seq=comic-cover-012&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    rating: 9.6,
    views: 2130000,
    description: '不明病毒席卷全球，感染者变成嗜血怪物。一群普通人被困在大型购物中心内，资源有限、信任危机、外部威胁，他们必须找到生存下去的方法。',
    chapters: [
      { id: 'ch-012-1', title: '第1话 第一天', number: 1, updateDate: '2026-08-01' },
      { id: 'ch-012-2', title: '第2话 被困', number: 2, updateDate: '2026-08-03' },
      { id: 'ch-012-3', title: '第3话 内部矛盾', number: 3, updateDate: '2026-08-05' },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['悬疑', '生存', '末日', '人性'],
  },
];

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((comic) => comic.id === id);
};

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return comics.filter((comic) => comic.categorySlug === categorySlug);
};

export const getHotComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestComics = (limit: number = 12): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, limit);
};

export const getTopRatedComics = (limit: number = 10): Comic[] => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, limit);
};

export const getRelatedComics = (comic: Comic, limit: number = 4): Comic[] => {
  return comics.filter((c) => c.id !== comic.id && c.categorySlug === comic.categorySlug).slice(0, limit);
};